<template>
  <v-container v-show="isMounted">
<!-- 
<v-card-title class="font-weight-bold">プログラム一覧</v-card-title>
 -->
  <v-data-table
    :headers="headers"
    :items="this.InputDataList"   
    locale="ja-jp"
    :footer-props="{
      //'disable-items-per-page':true,
      //'disable-pagination':true,
      //'items-per-page-all-text':'all',  //データ件数 all の日本語
      'items-per-page-text':'', //Rows per pageの所の日本語（削除）
    }"
  >
    <!-- 上書きしたい列を定義(ボタンに変更) -->
   <template v-slot:item.DummyButton="{ item }">
     <v-btn small rounded color="primary" @click="moveInput(item.PrimaryKey)">編集</v-btn>&nbsp;
     <v-btn small rounded color="error" @click="moveNotification(item.PrimaryKey)">通知</v-btn>&nbsp;
     <v-btn small rounded color="warning" @click="moveViewQR(item.ShortKey)">QR</v-btn>&nbsp;
     <v-btn small rounded color="success" @click="moveUserNotification(item.ShortKey)">Userサイト</v-btn>
   </template>
</v-data-table> 

<!-- 右下にボタンを追加 -->
<v-btn id="btnAdd" class="mx-2" fab dark small fixed bottom right color="red" @click="moveInput(null)">
  <v-icon dark>mdi-plus</v-icon>
</v-btn>

  </v-container>
</template>

<script>
//import firebase from "firebase/app";
import project from "../project.js";
const API_URL ="/api/inputprogramlist/";

export default {
  name: "inputprogramlist",  
  mounted: async function() {

        project.SetLoading(true);
        await this.search();
        project.SetLoading(false);
        this.isMounted = true;

    //project.SetLoading(true);

    //project.SetLoading(false);

    // let val = project.GetUrlVars();
    // if (
    //   this.InputData.Programs == null ||
    //   this.InputData.Programs.length < MAX_DUMMY_DATA
    // ) {
    //   let start = (this.InputData.Programs.length || 1) - 1;
    //   for (let i = start; i < MAX_DUMMY_DATA; i++) {
    //     this.InputData.Programs.push({ ProgramID: i + 1 });
    //   }
    // }
  },
  data: function() {
    return {
      isMounted : false ,
      headers:[
          { text: '', value: 'DummyButton' ,width:"310px",sortable: false ,align:"center"},
          { text: 'タイトル', value: 'Title' ,sortable: true},
          { text: '対象日', value: 'TargetDate',width:"120px",sortable: true},
      ],
      InputDataList: [],
      // Page: {
      //   PageLength :10 ,
      //   CurrentPage:1,
      // }
    };
  },
  methods: {
    search: async function() {
      await project.PostApi(API_URL + "search", null ,true).then(
        (data)=> {
          this.InputDataList = data;
        }
      ).catch((e)=> { 
          alert(e.message);     
      });    
    },
    
    moveInput: function(key) {
      if (key == null){
        this.$router.push({ name: 'inputprogram'});
      }
      else{
        this.$router.push({ name: 'inputprogram', query: { PrimaryKey: key }});
      }
      
    },

    moveNotification: function(key) {
      this.$router.push({ name: 'programnotification', query: { PrimaryKey: key }});
    },

    moveUserNotification: function(shortKey) {
      //this.$router.push({ name: 'usernotification', query: { sk: shortKey }});
      window.location.href='./confirm.html?' + shortKey
      
    },

    moveViewQR: function(shortKey) {
      let qrData = location.origin + '/confirm.html?' + shortKey
      this.$router.push({ name: 'viewqr', query: { qr: qrData }});
    },

  }
};
</script>